import { Navigate } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./layouts/AdminLayout";
import LoginPage from "./pages/LoginPage";
import UploaderPage from "./pages/UploaderPage";
import PayoutsPage from "./pages/PayoutsPage";
import PerformancePage from "./pages/PerformancePage";
import ProductsPage from "./pages/ProductsPage";

const routes = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/admin",
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="upload" replace /> },
          { path: "upload", element: <UploaderPage /> },
          { path: "payouts", element: <PayoutsPage /> },
          { path: "performance", element: <PerformancePage /> },
          { path: "products", element: <ProductsPage /> },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/admin" replace />,
  },
];

export default routes;